<template>
    <v-row no-gutters class="d-block">
        <v-col cols="12">
            <encabezado subtitulo="Aquí están sus constancias de INFOP" :cifras="cifras"/>

            <div class="barra">
                <h2 class="barra__titulo">Historial de constancias</h2>
                <v-btn text small color="primary" :loading="loading" @click="getConstancias()">
                    <v-icon small left>refresh</v-icon> Actualizar
                </v-btn>
                <v-text-field
                    v-if="constancias.length > 6"
                    v-model="search"
                    class="barra__buscador"
                    prepend-inner-icon="search"
                    label="Buscar por número, tipo o curso"
                    single-line hide-details outlined dense clearable
                    background-color="white"
                ></v-text-field>
            </div>

            <div class="controles" v-if="constancias.length">
                <v-chip-group v-model="vista" mandatory class="filtros" active-class="filtros__activo">
                    <v-chip small value="todas" outlined>Todas ({{ constancias.length }})</v-chip>
                    <v-chip small value="vigentes" outlined>Vigentes ({{ vigentes.length }})</v-chip>
                    <v-chip small value="vencidas" outlined>Vencidas ({{ vencidas.length }})</v-chip>
                </v-chip-group>

                <v-btn-toggle v-model="modo" mandatory dense class="modos" color="primary" group>
                    <v-btn v-for="m in MODOS" :key="m.valor" :value="m.valor" small text :title="m.titulo">
                        <v-icon small>{{ m.icono }}</v-icon>
                        <span class="modos__texto">{{ m.texto }}</span>
                    </v-btn>
                </v-btn-toggle>
            </div>

            <div class="tarjetas" v-if="loading && !constancias.length">
                <v-skeleton-loader v-for="n in 2" :key="n" type="article, actions"></v-skeleton-loader>
            </div>

            <div class="vacio" v-else-if="!constancias.length">
                <v-icon>description</v-icon>
                <div class="vacio__titulo">Aún no tiene constancias</div>
                <div>Aparecerán aquí cuando INFOP emita una constancia a su nombre.</div>
            </div>

            <div class="vacio" v-else-if="!visibles.length">
                <v-icon>search_off</v-icon>
                <div class="vacio__titulo">Sin resultados</div>
                <div v-if="search">No hay constancias que coincidan con "{{ search }}".</div>
                <div v-else>No tiene constancias {{ vista }}.</div>
            </div>

            <!-- Tarjetas -->
            <div class="tarjetas" v-else-if="modo === 'tarjetas'">
                <tarjeta-constancia v-for="item in visibles" :key="item.constancia_id" :constancia="item" @descargar="constanciaGenerate"/>
            </div>

            <!-- Por año de emisión -->
            <div v-else-if="modo === 'anios'">
                <section class="grupo" v-for="grupo in porAnio" :key="grupo.anio">
                    <h3 class="grupo__titulo">
                        {{ grupo.anio }}
                        <span class="grupo__detalle">{{ grupo.items.length }} {{ grupo.items.length == 1 ? 'constancia' : 'constancias' }}</span>
                    </h3>
                    <div class="tarjetas">
                        <tarjeta-constancia v-for="item in grupo.items" :key="item.constancia_id" :constancia="item" @descargar="constanciaGenerate"/>
                    </div>
                </section>
            </div>

            <!-- Lista compacta -->
            <ul class="compacta" v-else-if="modo === 'lista'">
                <li class="compacta__fila" v-for="item in visibles" :key="item.constancia_id">
                    <span class="compacta__marca compacta__marca--vacia"><v-icon small color="#8a93b2">description</v-icon></span>
                    <div class="compacta__texto">
                        <span class="compacta__nombre">{{ item.constancia_codigo }}</span>
                        <span class="compacta__meta">{{ item.tipo }} · {{ item.conteo_cursos }} {{ item.conteo_cursos == 1 ? 'curso' : 'cursos' }} · válida hasta {{ item.fecha_validez | fechaESP }}</span>
                    </div>
                    <span class="tarjeta__estado" :class="item.vigente ? 'tarjeta__estado--bien' : 'tarjeta__estado--mal'">{{ item.vigente ? 'Vigente' : 'Vencida' }}</span>
                    <v-btn icon small color="primary" :disabled="!item.vigente" :title="item.vigente ? 'Descargar constancia' : 'Constancia vencida'" @click="constanciaGenerate(item)">
                        <v-icon>download</v-icon>
                    </v-btn>
                </li>
            </ul>

            <!-- Detalles: tabla -->
            <v-card v-else class="detalles">
                <v-data-table
                    dense
                    :headers="encabezadosTabla"
                    :items="visibles"
                    item-key="constancia_id"
                    :items-per-page="15"
                    :footer-props="$store.state.footerPropsTable"
                >
                    <template v-slot:[`item.fecha_emitida`]="{ item }">{{ item.fecha_emitida | fechaESP }}</template>
                    <template v-slot:[`item.fecha_validez`]="{ item }">{{ item.fecha_validez | fechaESP }}</template>
                    <template v-slot:[`item.vigente`]="{ item }">
                        <span class="tarjeta__estado" :class="item.vigente ? 'tarjeta__estado--bien' : 'tarjeta__estado--mal'">{{ item.vigente ? 'Vigente' : 'Vencida' }}</span>
                    </template>
                    <template v-slot:[`item.acciones`]="{ item }">
                        <v-btn small outlined color="primary" :disabled="!item.vigente" @click="constanciaGenerate(item)">
                            <v-icon small left>download</v-icon> Descargar
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card>
        </v-col>

        <v-col cols="12">
            <v-dialog v-model="dialog" persistent transition="dialog-bottom-transition"
                    scrollable fullscreen>
                <v-card>
                    <v-toolbar dark color="info" dense >
                        <v-toolbar-title>Constancia generada</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="closePdfViewer">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <iframe ref="objectPDF"
                            :src="url_constancia"
                            width="100%"
                            height="100%"
                            @load="iframePdfLoaded"
                            >
                    </iframe>

                </v-card>
            </v-dialog>

            <v-dialog
                v-model="showModalConstancia"
                persistent
                width="300">
                <v-card
                    color="info"
                    dark>
                    <v-card-text class="pt-5">
                        Cargando Constancia
                        <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                        ></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-col>

    </v-row>

</template>

<script>
import Ls from "@/services/ls";
import Encabezado from "./Encabezado.vue";
import TarjetaConstancia from "./TarjetaConstancia.vue";

const CLAVE_MODO = "constancias_modo";

export default {
    name: "MisCursosListaConstancias",
    components: {Encabezado, TarjetaConstancia},
    props: {
        // Si es requerido falso, que sea Default Vacio
        getParams: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            MODOS: [
                {valor: "tarjetas", icono: "grid_view", texto: "Tarjetas", titulo: "Vista de tarjetas"},
                {valor: "lista", icono: "view_list", texto: "Lista", titulo: "Lista compacta"},
                {valor: "detalles", icono: "table_rows", texto: "Detalles", titulo: "Tabla con todos los datos"},
                {valor: "anios", icono: "calendar_view_month", texto: "Por año", titulo: "Agrupadas por año de emisión"},
            ],
            search: "",
            // 'todas' | 'vigentes' | 'vencidas'
            vista: "todas",
            modo: Ls.get(CLAVE_MODO) || "tarjetas",
            loading: false,
            constancias: [],
            dialog: false,
            showModalConstancia: false,
            url_constancia: null,
            encabezadosTabla: [
                {text: "No. de constancia", value: "constancia_codigo"},
                {text: "Tipo", value: "tipo"},
                {text: "Emitida", value: "fecha_emitida"},
                {text: "Válida hasta", value: "fecha_validez"},
                {text: "Cursos", value: "conteo_cursos", align: "end"},
                {text: "Estado", value: "vigente", sortable: false},
                {text: "", value: "acciones", sortable: false, align: "center"},
            ],
        }
    },

    computed: {
        vigentes() {
            return this.constancias.filter(c => c.vigente);
        },
        vencidas() {
            return this.constancias.filter(c => !c.vigente);
        },
        visibles() {
            const base = this.vista === "vigentes" ? this.vigentes : (this.vista === "vencidas" ? this.vencidas : this.constancias);
            const texto = this.sinTildes(this.search);
            if (!texto) return base;
            return base.filter(c => this.sinTildes(`${c.constancia_codigo} ${c.tipo} ${(c.cursos || []).map(x => x.nombre_curso).join(' ')}`).includes(texto));
        },
        porAnio() {
            const grupos = {};
            for (const item of this.visibles) {
                const anio = String(item.fecha_emitida || "").slice(0, 4) || "Sin fecha";
                (grupos[anio] = grupos[anio] || []).push(item);
            }
            return Object.keys(grupos).sort((a, b) => b.localeCompare(a)).map(anio => ({anio, items: grupos[anio]}));
        },
        cifras() {
            if (!this.constancias.length) return [];
            const cursos = this.constancias.reduce((suma, c) => suma + (Number(c.conteo_cursos) || 0), 0);
            const cifras = [
                {icono: "description", valor: this.vigentes.length, etiqueta: "Constancias vigentes"},
            ];
            if (this.vencidas.length) cifras.push({icono: "event_busy", valor: this.vencidas.length, etiqueta: "Constancias vencidas"});
            cifras.push({icono: "school", valor: cursos, etiqueta: "Cursos incluidos"});
            return cifras;
        },
    },

    watch: {
        modo(valor) {
            Ls.set(CLAVE_MODO, valor);
        },
    },

    methods: {
        sinTildes(texto) {
            return String(texto || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();
        },
        getConstancias() {
            this.loading = true;
            window.axios.get('/constancias/estudiantes').then(response => {
                if (response.data.success) {
                    this.constancias = response.data.data;
                } else if (response.data.success === false) {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(error => {
                    console.log(error)
                    this.$toast.error("No se pudo listar datos.");
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        constanciaGenerate(constancia) {
            if (!constancia.vigente) {
                this.$toast.warning("Esta constancia venció; si la necesita, solicite una nueva.");
                return;
            }

            this.showModalConstancia = true;
            // Enlace firmado del API; el formato antiguo solo si el backend aún no lo envía.
            let params = constancia.token_constancia || btoa(JSON.stringify({
                constancia_id: constancia.constancia_id
            }));
            this.pedirPdf(`${this.baseURLApi}/constancias/generate/${params}`, (url) => {
                this.url_constancia = url;
                this.dialog = true;
            });
        },
        pedirPdf(url, aplicar) {
            // Se descarga por el API para poder mostrar un aviso claro si el servidor
            // está ocupado, en vez de un error crudo dentro del visor.
            window.axios.get(url, {responseType: 'blob', timeout: 180000}).then(response => {
                aplicar(URL.createObjectURL(response.data));
            })
                .catch(async error => {
                    let mensaje = "No se pudo generar el documento. Espere unos segundos e intente de nuevo.";
                    try {
                        const texto = await error.response.data.text();
                        mensaje = JSON.parse(texto).message || mensaje;
                    } catch (e) { /* respuesta sin detalle */ }
                    this.showModalConstancia = false;
                    this.dialog = false;
                    this.$toast.error(mensaje, {timeout: 12000});
                });
        },

        iframePdfLoaded() {
            this.showModalConstancia = false;
            this.dialog = true;
        },
        closePdfViewer() {
            if (this.url_constancia) URL.revokeObjectURL(this.url_constancia);
            this.url_constancia = null;
            setTimeout(() => {
                this.showModalConstancia = false;
                this.dialog = false;
            }, 500);
        }
    },
    created() {
        if (!this.MODOS.some(m => m.valor === this.modo)) this.modo = "tarjetas";
        this.getConstancias();
    }
}
</script>

<style lang="scss" scoped>
@import "./tarjetas.scss";
</style>
